import type { SVGProps } from "react";
const Component = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    {...props}
  >
    <path
      d="M7.5 18V13C7.5 12.558 7.6756 12.1341 7.98816 11.8215C8.30072 11.5089 8.72464 11.3333 9.16667 11.3333H10.8333C11.2754 11.3333 11.6993 11.5089 12.0118 11.8215C12.3244 12.1341 12.5 12.558 12.5 13V18M4.16667 10.5H2.5L10 3L17.5 10.5H15.8333V16.3333C15.8333 16.7754 15.6577 17.1993 15.3452 17.5118C15.0326 17.8244 14.6087 18 14.1667 18H5.83333C5.39131 18 4.96738 17.8244 4.65482 17.5118C4.34226 17.1993 4.16667 16.7754 4.16667 16.3333V10.5Z"
      stroke="black"
      strokeOpacity="0.5"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default Component;
